export default __webpack_public_path__ + "images/info-icon-outline.95d53c979da971d8e256a11f457a74dd.png";